import React, {Component} from 'react'
import {connect} from 'react-redux'
import OnBoardingNatural from 'template/OnBoardingNatural';
import { onBoardingContents } from './constant';
import {fetchTeacher} from './ducks'
import { getSubscription } from 'containers/Main/ducks/subscription';

import TeacherTable from './TeacherTable'
import tableSettingsFactory from "./table-settings";
import Loading from 'components/UI/Loading'


const mapStateToProps = (state) => ({
  user: state.user,
  gSubscription: state.gSubscription,
  teacherList: state.teacherList
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchTeacher: (opts, state) => dispatch(fetchTeacher(opts, state)),
    getSubscription: (schoolId)=> dispatch(getSubscription(schoolId))
	};
};


class DefaultTab extends Component {
  constructor(props){
    super(props)

    this.fetchTeacherList = this.fetchTeacherList.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onItemsCountPerPageChange = this.onItemsCountPerPageChange.bind(this)
  }

  componentWillMount(){
    this.fetchTeacherList(1)
  }

  fetchTeacherList(newPageNumber, newAmountPerPage){
    let {teacherState, orderBy, keyword} = this.props
    const {itemsCountPerPage} = this.props.teacherList.pagination;
    const schoolId = localStorage.getItem('schoolId')

    this.props.fetchTeacher({
      schoolId,
      amount_per_page: newAmountPerPage || itemsCountPerPage,
      current_page_number: newPageNumber,
      order_by: orderBy,
      keyword
    }, teacherState)

  }

  onPageChange(activePage) {
    if (activePage == this.props.teacherList.pagination.activePage) {
      return;
    }

    this.fetchTeacherList(activePage);
  }

  onItemsCountPerPageChange(itemsCountPerPage){
    this.fetchTeacherList(1, itemsCountPerPage);
  }

  render(){
    let { teacherList, teacherState } = this.props;
    let {fetching, hasPermission, school_has_teacher, pagination} = teacherList

    this.tableSettings = tableSettingsFactory.call(this, teacherState);
    const content = onBoardingContents[teacherState];

    if(fetching){
      return <Loading />
    }

    if((school_has_teacher == false && content) || hasPermission == false){
      return(
        <OnBoardingNatural
          isShown={true}
          title={content.title}
          text={content.text}
          image={content.image}
          showArrow={content.showArrow}
        />
      )
    } else {
      return(
        <TeacherTable
          tableData={teacherList.list}
          settings={this.tableSettings}
          pagination={pagination}
          onItemsCountPerPageChange={this.onItemsCountPerPageChange}
          onPageChange={this.onPageChange}
        />
      )
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(DefaultTab)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/DefaultTab.js